import { isNullOrEmpty } from '../../utils/helper.utils';

export default function calcularPreco(
  precoFornecedor: number | null,
  precoCliente: number | null | undefined,
  impostoPercentual: number | null | undefined,
  compra: boolean,
  receita: boolean,
  arredondar = true
) {
  if (isNullOrEmpty(precoCliente)) {
    return {
      preco: Number(precoFornecedor || 0),
      imposto: 0,
      novoPrecoComMargem: 0,
      novoPrecoComMargemComImposto: 0,
      novaMargemFinal: 0,
      novaMargemFinalPorcentagem: 0,
    };
  }

  const fornecedor = Number(precoFornecedor || 0);
  const cliente = Number(precoCliente || 0);
  const imposto = cliente * (Number(impostoPercentual || 0) * 0.01);
  const clienteLiquido = cliente - imposto;
  let calculo = {
    preco: fornecedor,
    imposto,
    novoPrecoComMargem: cliente,
    novoPrecoComMargemComImposto: clienteLiquido,
    novaMargemFinal: cliente - fornecedor - imposto,
    novaMargemFinalPorcentagem: cliente !== 0 ? ((cliente - fornecedor - imposto) / cliente) * 100 : 0,
  };

  if (compra && receita) {
    const basePercentual = fornecedor - imposto;
    calculo = {
      preco: cliente,
      imposto,
      novoPrecoComMargem: fornecedor,
      novoPrecoComMargemComImposto: clienteLiquido,
      novaMargemFinal: fornecedor - cliente - imposto,
      novaMargemFinalPorcentagem: basePercentual !== 0 ? 100 - (cliente * 100) / basePercentual : 0,
    };
  } else if (compra && !receita) {
    calculo = {
      preco: fornecedor,
      imposto,
      novoPrecoComMargem: cliente,
      novoPrecoComMargemComImposto: clienteLiquido,
      novaMargemFinal: cliente - fornecedor - imposto,
      novaMargemFinalPorcentagem: fornecedor !== 0 ? (clienteLiquido / fornecedor) * 100 - 100 : 0,
    };
  } else if (!compra && receita) {
    calculo = {
      preco: cliente,
      imposto,
      novoPrecoComMargem: cliente,
      novoPrecoComMargemComImposto: clienteLiquido,
      novaMargemFinal: clienteLiquido,
      novaMargemFinalPorcentagem: cliente !== 0 ? (clienteLiquido / cliente) * 100 : 0,
    };
  }

  return arredondar
    ? {
        preco: Number(calculo.preco.toFixed(2)),
        imposto: Number(calculo.imposto.toFixed(2)),
        novoPrecoComMargem: Number(calculo.novoPrecoComMargem.toFixed(2)),
        novoPrecoComMargemComImposto: Number(calculo.novoPrecoComMargemComImposto.toFixed(2)),
        novaMargemFinal: Number(calculo.novaMargemFinal.toFixed(2)),
        novaMargemFinalPorcentagem: Number(calculo.novaMargemFinalPorcentagem.toFixed(2)),
      }
    : calculo;
}
